import React from "react";
import { Link } from "react-router-dom";

export default function Button({ btnLink, btnText, outline }) {
  return (
    <div>
      <Link
        className="button"
        to={btnLink}
        style={{ backgroundColor: outline }}
      >
        {btnText}
      </Link>
    </div>
  );
}
